import * as React from 'react';
import Stack from '@mui/material/Stack';
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import CardSignUp from './components/CardSignUp';

const SignUpContainer = styled(Stack)(({ theme }) => ({
  height: 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',
  minHeight: '100%',
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4),
  },
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
  },
}));

export default function SignUp() {

  return (
      <SignUpContainer direction="column" justifyContent="space-between"
        sx={{
          backgroundImage: "url('https://firebasestorage.googleapis.com/v0/b/xpediente-clinico.appspot.com/o/web%2F14933.jpg?alt=media&token=8cbcf2d8-e15d-47c9-b863-96eeeb8b1dd4')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>
        <CardSignUp login={true}></CardSignUp>
      </SignUpContainer>)
}